import axios from 'axios';

// 🔥 если фронт и бек на одном домене
const API_URL = 'https://dbc5e65d6719.vps.myjino.ru/api';

// 🔥 если отдельно (например localhost)
// const API_URL = 'http://localhost:8000';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// =========================
// TOKEN INTERCEPTOR (REQUEST)
// =========================
api.interceptors.request.use((config) => {

    const token = localStorage.getItem('token');

    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});


// =========================
// RESPONSE INTERCEPTOR (401 AUTO LOGOUT)
// =========================
api.interceptors.response.use(
    (response) => response,
    (error) => {

        if (error.response?.status === 401) {

            // 🔥 очищаем данные
            localStorage.removeItem("token");
            localStorage.removeItem("user");

            // 🔥 редирект на логин
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);


// =========================
// AUTH
// =========================
export const auth = {

    register: (data) =>
        api.post('/auth/register', data),

    login: (data) =>
        api.post('/auth/token', data),

    getMe: () =>
        api.get('/auth/me'),

    getHistory: () =>
        api.get('/auth/history'),

    logout: () =>
        api.post('/auth/logout'),

    yandexLogin: () =>
        api.get('/auth/yandex'),
};


// =========================
// SEARCH
// =========================
export const search = {

    searchItems: (query) =>
        api.post('/search', { query }),

    getByKtru: (ktru) =>
        api.post('/ktru', { ktru }),

    getKtruDashboard: (ktru) =>
        api.post('/ktru/dashboard', { ktru }),

    getStats: () =>
        Promise.resolve({ data: {} }),
};


// =========================
// ANALYTICS
// =========================
export const analytics = {
    track: (event_type, data = {}) =>
        api.post('/analytics/track', { event_type, ...data }).catch(() => {}),
};

export default api;